export default __webpack_public_path__ + "static/media/m-review4.596db173.png";